import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AddVesselDialogComponent } from '../add-vessel-dialog/add-vessel-dialog.component';
import { AuthService } from '../shared/auth.service';
import { LocalStorageService } from '../shared/local-storage.service';
import { OperatorUser } from '../shared/operator-user.model';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { VesselData } from './vessel-data.model';

/**
 * From signup we come here. User may register their vessel(s) before their first login.
 */
@Component({
    selector: 'app-vessel-reg',
    templateUrl: './vessel-reg.component.html',
    styleUrls: ['./vessel-reg.component.css'],
    standalone: false
})
export class VesselRegComponent implements OnInit {


  vesselAdded: boolean = true;

  addedVessels: VesselData[] = [];

  user!: OperatorUser;


  constructor(public dataSync: LocalStorageService,
    public dialog: MatDialog,
     private router: Router,
      private route: ActivatedRoute,
       private auth: AuthService,
        private toastr: ToastrService) { }

  /**
   * New user data from signup is passed via the vessel-reg-resolver service
   */
  ngOnInit(): void {
    this.route.data
    .subscribe(data => {
      const user: OperatorUser = data['user'];
      this.user = user;
      this.dataSync.current_user.set(this.user);
      this.dataSync.accessToken.set(this.user.accessToken);
      this.dataSync.refreshToken.set(this.user.refreshToken);
    });
  }

  /**
   * Adding a new vessel
   * @param index Index into added vessels array
   * @param edit Are we editing an already added vessel or added a new one?
   */
  onAddVesselBtnClick(index: number, isEdit: boolean): void {
    if (index >= this.addedVessels.length) {
      this.addedVessels.push(new VesselData('', ''));
    }

    const dialogRef = this.dialog.open(AddVesselDialogComponent, {
      autoFocus: false,
      width: '450px',
      height: '350px',
      data: {
        vessel: this.addedVessels[index],
        edit: isEdit 
      }
    });

    let postRefresh = (item: VesselData, result: any) => {
      this.auth.postRefreshToken().subscribe(res => {
        let user = this.dataSync.current_user();
        user.accessToken = res.accessToken;
        user.refreshToken = res.refreshToken;
        this.dataSync.current_user.set(user);
        this.dataSync.accessToken.set(res.accessToken);
        this.dataSync.refreshToken.set(res.refreshToken);
        this.dataSync.updateUser(false, true);
        this.auth.postVesselSearch(result.vesselNumber).subscribe((list: any[]) => {
          item.vesselName = result.vesselName;
          item.vesselCoastNumber = result.vesselNumber;
          item.isRecognized = (list.length > 0);
          if (item.isRecognized) this.toastr.success('Recognized vessel added.', 'Success');
          else this.toastr.warning('Vessel ' + item +  ' is not recognized. Review for typos before continuing', 'Unrecognized vessel') 
        });
      });
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'delete') {
          this.addedVessels.splice(index, 1);
        } else {
          let item = this.addedVessels[index];
          if (this.auth.checkAccessToken().expired) {
            console.log("Access token expired, refreshing..");
            if (this.auth.checkRefreshToken().expired) {
              //Go to menu screen
              this.toastr.warning('Login to add and view your vessels' ,'Sign-up session expired');
              this.router.navigate(['menu']);
            } else {             
              postRefresh(item, result);         
            }
          } else {
            postRefresh(item, result);
          }               
        }
      } else if (!isEdit) {
        this.addedVessels.splice(index, 1);
      }     
    });
  }


  /**
   * Go to login. Check if added vessels are not server recognized or if no vessels have been added at all.
   */
  onConfirmBtnClick() {
    //Confirm if unrecognized vessels
    let completeVesselReg = () => {
      this.dataSync.current_user.set(this.user);
      this.dataSync.sign_up.set(true);
      this.dataSync.updateUserVessels(this.user.userName.toLowerCase(), this.addedVessels, true).then(res => this.router.navigate(['login']));
    }

    if (this.addedVessels.filter(v => !v.isRecognized).length > 0) {
      this.dialog.open(ConfirmDialogComponent, {
        data: {screen: 'vesselreg', vessels: this.addedVessels.filter(v => !v.isRecognized)}
      }).afterClosed().subscribe(result => {
        if (result) completeVesselReg();     
      });

    } else {
      completeVesselReg()
    } 
  }

}
